import PoleSize from "./types/PoleSize";

export const GAME_CONFIG: PoleSize = {height: 6, width: 7};